import React, { Component } from "react";
import { Container, Grid, Typography } from "@material-ui/core";
import { GetData } from "../api/service";
import CommitteeDescription from "../component/Committee/CommitteeDescription";
import "../component/section-sidebar.css";

// // import FacilityDescription from "./FacilityDescription";

// const list = [
//     {
//         title: "Library",
//         link: "/facility/library",
//     },
//     {
//         title: "Boys Hostel",
//         link: "/facility/boyshostel",
//     },
//     {
//         title: "Girls Hostel",
//         link: "/facility/girlshostel",
//     },
//     {
//         title: "CIF",
//         link: "/facility/cif",
//     },
//     {
//         title: "Canteen",
//         link: "/facility/canteen",
//     },
//     {
//         title: "ICGC",
//         link: "/facility/icgc",
//     },
// ];

class CommitteesContainer extends Component {
    state = {
        link: "",
        data:[],
        isLoaded:false,
        com:{},
        child:false,
        query: ""
    };

    componentDidMount() {
        let link = this.props.match.params.link;
        this.setState({
            link: link,
        });
        GetData(`/getcommittee`)
        .then((resp) => {
          this.setState({
            data: resp,
            isLoaded: true
          })
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.match.params.link != this.props.match.params.link) {
            let link = this.props.match.params.link;
            this.setState({
                link: link,
            });
        }
    }

    setCom(d){
       
      this.setState({
        child:false
      },()=>{
        this.setState({
            com: d,
            child:true
          })
      })
    //   console.log(this.state);
    }

    render() {
        const query = this.state.query.trim().toLowerCase();
        const filtered = query
            ? this.state.data.filter((el) =>
                  (el.name || "").toLowerCase().includes(query)
              )
            : this.state.data;

        return (
            <div className="snav-wrap">
                <Container>
                    <Grid container spacing={4}>
                        <Grid item xs={12} sm={12} md={3} lg={3}>
                            <nav className="snav-side">
                                <div className="snav-side-head">Committees</div>
                                <div className="snav-search">
                                    <div className="snav-search-field">
                                        <span className="fa fa-search" aria-hidden="true" />
                                        <input
                                            type="text"
                                            className="snav-search-input"
                                            placeholder="Search committees..."
                                            value={this.state.query}
                                            onChange={(e) =>
                                                this.setState({ query: e.target.value })
                                            }
                                        />
                                    </div>
                                </div>
                                <ul className="snav-side-list">
                                    {filtered.length === 0 ? (
                                        <li className="snav-side-empty">
                                            {this.state.isLoaded
                                                ? "No matching items"
                                                : "Loading..."}
                                        </li>
                                    ) : (
                                        filtered.map((el, index) => (
                                            <li
                                                key={index}
                                                className={`snav-side-item${
                                                    this.state.child &&
                                                    this.state.com &&
                                                    el.name === this.state.com.name
                                                        ? " active"
                                                        : ""
                                                }`}
                                                onClick={() => this.setCom(el)}
                                            >
                                                <span className="snav-dot" />
                                                {el.name}
                                            </li>
                                        ))
                                    )}
                                </ul>
                            </nav>
                        </Grid>

                        <Grid item xs={12} sm={12} md={9} lg={9}>
                            <Typography variant="h4" style={{ margin: "1em 0 0 0" }} gutterBottom>
                                Committees
                            </Typography>
                            <small><br/> (Click on the name of the committee on the left side To view details)</small>

                            <hr />
                            {this.state.child && <CommitteeDescription data={this.state.com} />}
                        </Grid>

                    </Grid>
                </Container>
            </div>
        );
    }
}

export default CommitteesContainer;